import { render, staticRenderFns } from "./BillingEvent.vue?vue&type=template&id=2b6c010c&"
import script from "./BillingEvent.vue?vue&type=script&lang=js&"
export * from "./BillingEvent.vue?vue&type=script&lang=js&"
import style0 from "./BillingEvent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports